import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTrialOnboarding as GetTrialOnboardingQuery,
    GetTrialOnboarding_trialOnboarding as TrialOnboarding,
} from 'nutshell-graphql-types';

import GET_TRIAL_ONBOARDING from '../queries/get-trial-onboarding.graphql';

export const useGetTrialOnboarding = (): {
    trialOnboarding: TrialOnboarding | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetTrialOnboardingQuery, Record<any, any>>(
        GET_TRIAL_ONBOARDING,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        trialOnboarding: data && data.trialOnboarding,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
